import { useUser } from "../../contexts/UserContext/UserContext";

/**
 * Hook that returns a function to get authentication headers for API requests
 * @returns A function that returns a Promise resolving to authorization headers
 */
export const useAuthHeaders = () => {
  const { accessToken } = useUser();
  
  return (): Promise<Record<string, string> | undefined> => {
    const headers: Record<string, string> | undefined = accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined;
    return Promise.resolve(headers);
  };
};

/**
 * Hook that returns a function to get authentication headers for API requests
 * Always returns a Record (empty object if no token)
 * @returns A function that returns a Promise resolving to authorization headers
 */
export const useAuthHeadersRequired = () => {
  const { accessToken } = useUser();
  
  return (): Promise<Record<string, string>> => {
    const headers: Record<string, string> = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
    return Promise.resolve(headers);
  };
};
